import {forwardRef} from "react";
import {Project} from "../../../../../api/Projects";
import {Company} from "../../../../../api/Companies";
import {useUser} from "../../../../../misc/Permission";
import {PDF} from "../../../../../misc/pdf/parts/PDF";
import {ClientInfoContextProvider, PDFProjectContext} from "../../openings/OpeningsPDF";
import {useReadyCheck} from "../../../../../misc/pdf/UseReadyCheck";
import {CoverPage} from "../../../../../misc/pdf/parts/CoverPage";
import {Contact} from "../../../../../api/Contacts";

export const Div10SimplePDF = forwardRef(function(props: {
    lastSubmittal: string|null;
    project: Project;
    client?: Company;
    clientContact?: Contact;
    onReady(): void;
}, ref: any) {
    const usr = useUser();

    const ready = useReadyCheck(props.onReady);
    ready.require(!!usr);

    return (
        <div ref={ref}>
            <PDF>
                <PDFProjectContext.Provider value={props.project}>
                    <ClientInfoContextProvider client={props.client} clientContact={props.clientContact}>
                        <CoverPage title="DIV 8 & DIV 10 CUT SHEETS" lastSubmittal={props.lastSubmittal} />
                    </ClientInfoContextProvider>
                </PDFProjectContext.Provider>
            </PDF>
        </div>);
});